<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <button
                        @click="preValidateForm()"
                        class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 -mt-10 py-3 px-6 rounded">
                        {{ escrow_account ? 'Solicitar transferência' : 'Transferir' }}
                    </button>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Transferência entre contas<br/>
                    <span class="text-xs">Cadastre favorecidos e realize transferências para qualquer banco</span>
                </h2>
            </div>
        </template>
        <div>
            <div class="max-w-7xl mx-auto mt-10 py-10 sm:px-6 lg:px-8">
                <flash :timeout="5000"/>

                <template>
                    <jet-form-section>
                        <template #title>
                            Para quem
                        </template>

                        <template #description>
                            Informe a conta e os dados de quem receberá o dinheiro.
                            Transferências somente são permitidas para favorecidos cadastrados.
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-5">
                                <jet-label for="bank" value="Favorecido"/>
                                <jet-auto-complete
                                    id="contact" class="mt-1 block w-full"
                                    :endpoint="'contacts'"
                                    :auto-load="true"
                                    place-holder="Nenhum favorecido encontrado. Clique em NOVO para cadastrar um favorecido."
                                    :custom-option="customOption"
                                    v-model="form.contact"/>
                                <jet-input-error :message="form.error('account.contact')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-1">
                                <inertia-link
                                    class="w-full inline-flex items-center mt-6 px-4 py-3 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                                    :href="route('contact.create')">
                                    <div class="w-full text-center">Novo</div>
                                </inertia-link>
                            </div>
                            <div class="col-span-6 sm:col-span-6 -mt-4 text-right">
                                <inertia-link class="text-xs" :href="route('contact.index')">Gerenciar favorecidos
                                </inertia-link>
                            </div>

                            <div class="col-span-6 sm:col-span-6" v-if="form.contact.name">
                                <div v-if="hasAccounts">
                                    <p>Escolha a conta de destino:</p>
                                    <ul>
                                        <li class="my-2 flex"
                                            v-for="(account, index) in listAccount(form.contact.transfer_accounts, form)"
                                            :key="index">
                                            <input type="radio"
                                                   v-bind:id="`selected_account${index}`"
                                                   :value="account"
                                                   name="selected_account"
                                                   v-model="form.selected_account"
                                                   class="form-radio h-5 w-5 mr-3 text-gray-600"/>
                                            <label v-bind:for="`selected_account${index}`">
                                                <span v-if="account.type !== 'PIX'">
                                                    {{ account.bank ? account.bank.name : '' }} | </span>
                                                <span v-if="account.type !== 'PIX'">
                                                    {{ account.name }}
                                                    <span class="text-xs">Agência </span> {{ account.agency }}
                                                    <span class="text-xs">Conta </span> {{
                                                        account.number
                                                    }} ({{ account.type }})</span>

                                                <span v-if="account.type === 'PIX'"><span
                                                    class="text-xs">PIX Chave </span> {{
                                                        account.key
                                                    }} |  {{ account.name }}</span>
                                            </label>
                                        </li>
                                    </ul>

                                    <div v-if="showTransferType">
                                        <p>Escolha o tipo de transferência:</p>
                                        <ul>
                                            <li class="my-2 flex" v-for="(type, index) in transferType" :key="index">
                                                <input type="radio"
                                                       v-bind:id="`selected_tyPe${type}`"
                                                       :value="type"
                                                       name="selected_type"
                                                       v-model="form.transfer_type.name"
                                                       class="form-radio h-5 w-5 mr-3 text-gray-600"/>
                                                <label v-bind:for="`selected_tyPe${type}`">
                                                    <span>{{ type }}</span>
                                                </label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <inertia-link
                                        class="inline-flex mt-3 text-xs items-center px-4 py-1 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                                        :href="`/contact/${form.contact.id}`">Editar
                                    </inertia-link>
                                </div>
                                <div class="mt-2 text-left">
                                    <span v-show="searchingKey"><i class="fa fa-spin fa-spinner"> </i> Buscando dados da chave Pix.</span>

                                    <div class="pa-1" v-show="!searchingKey && pixKeyDetails.chave != null">
                                        <p>Dados da chave pix:</p>
                                        <p class="mt-2"><b>Correntista: </b> {{ pixKeyDetails.nomeCorrentista }}</p>
                                        <p v-show="pixKeyDetails.tipoPessoa == 'PJ'"><b>Nome Fantasia: </b>
                                            {{ pixKeyDetails.nomeFantasia }}</p>
                                        <p><b>Documento: </b> {{ pixKeyDetails.documentoFederal }}</p>
                                        <hr class="my-2">
                                        <p><b>Banco: </b> {{ pixKeyDetails.banco.numero }} -
                                            {{ pixKeyDetails.banco.descricao }}</p>
                                        <p><b>Agencia: </b> {{ pixKeyDetails.conta.agencia }}</p>
                                        <p><b>Conta: </b> {{ pixKeyDetails.conta.conta }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-span-6 sm:col-span-6" v-if="formErrors.contact">
                                <jet-input-error :message="formErrors.contact" class="mt-2"/>
                            </div>


                        </template>
                    </jet-form-section>
                </template>

                <jet-section-border/>


                <template>
                    <jet-form-section>
                        <template #title>
                            Transferência
                        </template>

                        <template #description>
                            Informe o valor a ser transferido
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-3">
                                <jet-label for="amount" value="Valor"/>
                                <jet-decimal id="amount" type="text" class="mt-1 block w-full text-lg"
                                             v-model="form.amount"/>
                                <jet-input-error :message="form.error('amount')" class="mt-2"/>
                                <jet-input-error :message="formErrors.amount" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-1 text-right"></div>
                            <div class="col-span-6 sm:col-span-2 text-right">
                                <balance/>
                            </div>
                        </template>
                    </jet-form-section>
                </template>

                <jet-section-border/>

                <template>
                    <jet-form-section>
                        <template #title>
                            Detalhes da transação
                        </template>

                        <template #description>
                            Complete os detalhes da transação.
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-6" v-if="form.transfer_type.name !== 'PIX'">
                                <jet-label for="goal" value="Finalidade"/>
                                <jet-auto-complete
                                    id="goal"
                                    :options-list="goal_list"
                                    class="mt-1 block w-full "
                                    v-model="form.goal"/>
                                <jet-input-error :message="form.error('goal')" class="mt-2"/>
                                <jet-input-error :message="formErrors.goal" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-3">
                                <jet-label for="description" value="Descrição"/>
                                <jet-input id="description" type="text" class="mt-1 block w-full"
                                           maxlength="40"
                                           v-model="form.description"/>
                                <jet-input-error :message="form.error('description')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-3">
                                <jet-label for="receiver_code" value="Identificador da transação"/>
                                <jet-input id="receiver_code"
                                           maxlength="40"
                                           type="text" class="mt-1 block w-full"
                                           v-model="form.receiver_code"/>
                                <jet-input-error :message="form.error('receiver_code')" class="mt-2"/>
                            </div>
                        </template>
                    </jet-form-section>
                    <jet-section-border/>
                    <div class="text-right">
                        <button
                            @click="preValidateForm()"
                            class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 -mt-10 py-3 px-6 rounded">
                            {{ escrow_account ? 'Solicitar transferência' : 'Transferir' }}
                        </button>
                    </div>
                </template>

                <jet-section-border/>

            </div>

            <jet-confirmation-modal :show="reviewTransfer" @close="reviewTransfer=false">
                <template #title>
                    Confirme os dados
                </template>

                <template #content>

                    <template>
                        <jet-section-border/>
                        <jet-form-section>
                            <template #title>
                                Dados da transação
                            </template>

                            <template #description>
                                Verifique se as informações estão corretas antes de finalizar a transferência.
                            </template>

                            <template #form class=" gap-0">
                                <div class="col-span-6 sm:col-span-6">
                                    <table class="w-full">
                                        <template>
                                            <tr>
                                                <td class="px-2 py-2 text-sm" colspan="2">
                                                    <span class="text-3xl font-extrabold">
                                                        R$ {{ form.amount }}</span><br/>
                                                    Para <span class="font-bold">{{ form.contact.name }}</span>
                                                    <jet-input-error :message="form.error('amount')" class="mt-2"/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-2 py-2 text-sm font-bold">CPF</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ form.contact.federal_document || '' }}
                                                </td>
                                            </tr>
                                            <tr v-if="form.selected_account.type !== 'PIX'">
                                                <td class="px-2 py-2 text-sm font-bold">Instituição</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ form.selected_account.bank.name || '' }}
                                                </td>
                                            </tr>
                                            <tr v-if="form.selected_account.type !== 'PIX'">
                                                <td class="px-2 py-2 text-sm font-bold">Agência</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ form.selected_account.agency || '' }}
                                                </td>
                                            </tr>
                                            <tr v-if="form.selected_account.type !== 'PIX'">
                                                <td class="px-2 py-2 text-sm font-bold">Conta</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ form.selected_account.number || '' }}
                                                </td>
                                            </tr>
                                            <tr v-if="form.selected_account.type == 'PIX'">
                                                <td class="px-2 py-2 text-sm font-bold">Chave Pix</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ form.selected_account.key || '' }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-2 py-2 text-sm font-bold">Tipo transferência</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{
                                                        (form.transfer_type.name == 'PIX' ? 'PIX' : form.selected_account.bank.id === '274'
                                                            ? `Entre contas ${$page.props.white_label.data.short_name}`
                                                            : 'TED')
                                                    }}
                                                </td>
                                            </tr>

                                            <tr v-if="form.selected_account.type == 'PIX' && pixKeyDetails.chave != null">
                                                <td class="px-2 py-2 text-sm font-bold">Favorecido</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ pixKeyDetails.nomeCorrentista }}
                                                </td>
                                            </tr>

                                            <tr v-if="form.selected_account.type == 'PIX' && pixKeyDetails.chave != null">
                                                <td class="px-2 py-2 text-sm font-bold">Documento</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ pixKeyDetails.documentoFederal }}
                                                </td>
                                            </tr>

                                            <tr v-if="form.selected_account.type == 'PIX' && pixKeyDetails.chave != null">
                                                <td class="px-2 py-2 text-sm font-bold">Banco</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ pixKeyDetails.banco.numero }} - {{
                                                        pixKeyDetails.banco.descricao
                                                    }}
                                                </td>
                                            </tr>

                                            <tr v-if="form.selected_account.type == 'PIX' && pixKeyDetails.chave != null">
                                                <td class="px-2 py-2 text-sm font-bold">Agência</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ pixKeyDetails.conta.agencia }}
                                                </td>
                                            </tr>

                                            <tr v-if="form.selected_account.type == 'PIX' && pixKeyDetails.chave != null">
                                                <td class="px-2 py-2 text-sm font-bold">Conta</td>
                                                <td class="px-2 py-2 text-sm text-right">
                                                    {{ pixKeyDetails.conta.conta }}
                                                </td>
                                            </tr>

                                            <tr v-if="form.transfer_type.name !== 'PIX'">
                                                <td class="px-2 py-2 text-sm font-bold">Finalidade</td>
                                                <td class="px-2 py-2 text-sm text-right">{{ form.goal.name || '' }}</td>
                                            </tr>
                                        </template>
                                    </table>
                                </div>

                            </template>
                        </jet-form-section>
                        <jet-section-border/>
                        <jet-form-section>
                            <template #title>
                                Autenticação
                            </template>

                            <template #description>
                                Informe o código de autorização para autenticar sua solicitação
                            </template>

                            <template #form>
                                <div class="col-span-6 sm:col-span-6">
                                    <jet-label for="google_code" value="Código de Autorização"/>
                                    <jet-input id="google_code" type="number" class="mt-1 block w-full"
                                               v-model="form.google_code"/>
                                    <jet-input-error :message="form.error('google_code')" class="mt-2"/>
                                </div>
                            </template>
                        </jet-form-section>
                    </template>


                </template>

                <template #footer>
                    <jet-secondary-button @click.native="reviewTransfer = false">
                        Agora não
                    </jet-secondary-button>

                    <jet-ok-button class="ml-2" @click.native="transfer()"
                                   :class="{ 'opacity-25': form.processing }"
                                   :disabled="form.processing">
                        Confirmar
                    </jet-ok-button>
                </template>
            </jet-confirmation-modal>
        </div>

    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetActionMessage from "../../Jetstream/ActionMessage";
import JetButton from "../../Jetstream/Button";
import JetFormSection from "../../Jetstream/FormSection";
import JetInput from "../../Jetstream/Input";
import JetTextarea from "../../Jetstream/Textarea";
import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import JetInputError from "../../Jetstream/InputError";
import JetLabel from "../../Jetstream/Label";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetMaskedInput from "../../Jetstream/MaskedInput";
import JetFetchDoc from "../../Jetstream/FetchDoc";
import JetDatePicker from "../../Jetstream/DatePicker";
import JetRadio from "../../Jetstream/Radio";
import JetDecimal from "../../Jetstream/Decimal";
import JetConfirmationModal from "../../Jetstream/ConfirmationModal";
import JetDangerButton from "../../Jetstream/DangerButton";
import JetOkButton from "../../Jetstream/OkButton";
import Flash from "../../Helpers/Flash"
import Balance from "../../Helpers/Balance";

export default {
    props: ['goal_list', 'errors','escrow_account'],
    methods: {
        startTransferTimeOutCount() {
            this.timer = setTimeout(this.redirectAfterTimeOut, 30000);
        },
        redirectAfterTimeOut() {
            if (this.timer !== null) {
                this.$inertia.visit('/extract?transferTimedOut=true');
            }
        },
        transfer() {
            // this.startTransferTimeOutCount();
            this.form.post('/transfer', {
                preserveScroll: true,
                onError: (e) => {
                    clearTimeout(this.timer);
                    this.form.processing = false;
                    this.reviewTransfer = (this.errors.google_code) ? true : false;
                    this.form.google_code = null;
                    this.$forceUpdate();
                },
                onSuccess: () => {
                    clearTimeout(this.timer);
                }
            });
        },
        customOption: (option) => {
            return `${option.name} | <span class="text-xs">${option.federal_document}</span>`;
        },
        listAccount: (list, form) => {
            if (list.length === 1) {
                form.selected_account = list[0];
            }

            return list;
        },
        preValidateForm() {
            let hasErrors = false;

            this.formErrors = {
                amount: null,
                goal: null,
                contact: null
            }

            if (!this.form.contact.id) {
                this.formErrors.contact = 'Esse campo é obrigatório';
                hasErrors = true;
            }
            if (this.form.selected_account.type !== "PIX") {
                if (!this.form.selected_account.agency) {
                    this.formErrors.contact = (this.form.contact?.transfer_accounts.length == 0)
                        ? 'É necessário cadastrar pelo menos uma conta para o favorecido.'
                        : 'Esse campo é obrigatório';
                    hasErrors = true;
                }
                if (!this.form.goal.id && this.form.transfer_type.name != "PIX") {
                    this.formErrors.goal = 'Esse campo é obrigatório';
                    hasErrors = true;
                }

            } else {
                if (!this.form.selected_account.key) {
                    this.formErrors.contact = 'Esse campo é obrigatório';
                    hasErrors = true;
                }
            }
            if (this.form.transfer_type.name == "PIX") {
                this.form.goal = {
                    id: 99999,
                    name: "Outros"
                }
            }
            if (!hasErrors) {
                this.reviewTransfer = true;
                window.scrollTo(0, 0);
            }

            return true;
        },
        validateKey() {
            //
            this.searchingKey = true;
            fetch(`json/pix/key/validate?key=${this.form.selected_account.key}`)
                .then(res => {
                    res.json().then(json => {
                        if (json.error) {
                            this.$toast.open({
                                message: json.error,
                                type: 'error',
                                duration: 5000,
                                position: 'top-right'
                            });
                            this.pixKeyDetails.chave = null;
                            if (this.form.contact.transfer_accounts.length > 1) {
                                if (this.form.contact.transfer_accounts.key != this.form.selected_account.key)
                                    this.form.selected_account = this.form.contact.transfer_accounts[0];
                            }
                            return;
                        }

                        this.pixKeyDetails = json;
                    });
                })
                .finally(() => {
                    this.searchingKey = false;
                })
        }
    },
    watch: {
        'form.selected_account': {
            handler: function (acc) {
                if (acc.type !== null) {
                    if (acc.type == "PIX") {
                        this.showTransferType = false;
                        this.form.transfer_type.name = "PIX";
                        this.validateKey();
                    } else {
                        this.pixKeyDetails.chave = null;
                        if (acc.bank.id === "274") {
                            this.transferType = ['Entre contas', 'PIX'];
                            this.form.transfer_type.name = "Entre contas";
                        } else {
                            this.transferType = ['TED', 'PIX'];
                            this.form.transfer_type.name = "TED";
                        }
                        this.showTransferType = true;
                    }
                } else {
                    this.pixKeyDetails.chave = null;
                    this.showTransferType = false;
                }
            }
        },
        'form.transfer_type.name': {
            handler: function (v) {
                if (this.form.selected_account.type !== "PIX" && v == "PIX") {
                    this.pixKeyDetails = {
                        chave: "PIX",
                        tipoChave: "99",
                        nomeCorrentista: this.form.contact.name,
                        nomeFantasia: "",
                        tipoPessoa: this.form.contact.federal_document.length == 14 ? "PF" : "PJ",
                        documentoFederal: this.form.contact.federal_document,
                        conta: {
                            conta: this.form.selected_account.number,
                            tipoConta: "",
                            agencia: this.form.selected_account.agency,
                            ispb: ""
                        },
                        banco: {
                            descricao: this.form.selected_account.bank.name,
                            numero: "",
                            ispb: "",
                            detalhesConsulta: "",
                            mensagem: null
                        },
                    };
                } else {
                    this.pixKeyDetails.chave = null;
                }
            }
        },
        'form.contact': {
            handler: function (newForm) {
                if (newForm == null) {
                    this.form.contact = {
                        name: null,
                        federal_document: null,
                    };

                    return;
                }
                this.form.selected_account = {
                    agency: null,
                    bank: {
                        id: null,
                        name: null
                    },
                    number: null,
                    key: null,
                    type: null
                };
                this.formErrors.contact = null;
            },
            deep: true,
        },
        'errors': {
            handler: function () {
                clearTimeout(this.timer);
            }
        },
    },
    computed: {
        hasAccounts() {
            if (this.form.contact.transfer_accounts === undefined ||
                this.form.contact.transfer_accounts.length == 0) {
                return false;
            }
            return true;
        }
    },
    data() {
        return {
            timer: null,
            flashIsVisible: true,
            reviewTransfer: false,
            cancelTransfer: null,
            showTransferType: false,
            selectedContact: null,
            searchingKey: false,
            formErrors: {
                amount: null,
                goal: null,
                contact: null
            },
            pixKeyDetails: {
                chave: null,
                tipoChave: null,
                nomeCorrentista: null,
                nomeFantasia: null,
                tipoPessoa: null,
                documentoFederal: null,
                conta: {
                    conta: null,
                    tipoConta: null,
                    agencia: null,
                    ispb: null
                },
                banco: {
                    descricao: null,
                    numero: null,
                    ispb: null,
                    detalhesConsulta: null,
                    mensagem: null
                },
            },
            transferType: ['TED', 'PIX'],
            form: this.$inertia.form({
                _method: 'POST',
                amount: 0,
                contact: {
                    name: null,
                    federal_document: null,
                },
                transfer_type: {
                    name: 'TED'
                },
                selected_account: {
                    agency: null,
                    bank: {
                        id: null,
                        name: null
                    },
                    number: null,
                    key: null,
                    type: null
                },
                federal_document: null,
                goal: {},
                google_code: null,
                receiver_code: null,
                description: null
            }, {
                resetOnSuccess: false,
            }),
        }
    },
    components: {
        Balance,
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetRadio,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
        JetDatePicker,
        JetDecimal,
        JetConfirmationModal,
        JetDangerButton,
        JetOkButton
    },
}
</script>
